import * as io from 'io-ts';
import { nullable, validString, deprecatedType } from '@shared/core/types/common';
import { defaultForEmptyOrderType, orderTypeIdsArray } from '@shared/core/types/consts';

const locationListPageCommonDefinition: io.MixedObject<OLO.Config.LocationListPage.Common> = {
    listResultsCountText: validString,
    listResultsCountTextPlural: validString,
};

const rootDefinition: io.MixedObject<OLO.Config.LocationListPage> = {
    orderTypeIds: orderTypeIdsArray,
    locationMode: io.union([nullable(io.type(locationListPageCommonDefinition)), defaultForEmptyOrderType]),
    venueMode: deprecatedType,
};

export const locationListPageSchema = io.array(io.type(rootDefinition));
